<div class="page">

  <div class="page-header">
    <div class="header-left">
      <button class="btn-back" (click)="goBack()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
        Back
      </button>
      <div>
        <h1>New Ad</h1>
        <p>Create a new advertisement</p>
      </div>
    </div>
  </div>

  <div class="error-msg" *ngIf="errorMessage">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/>
      <line x1="12" y1="16" x2="12.01" y2="16"/>
    </svg>
    {{ errorMessage }}
  </div>

  <form class="form-card" (ngSubmit)="onSubmit()">

    <!-- Basic Info -->
    <div class="form-section">
      <h2 class="section-title">Ad Info</h2>

      <!-- Title — bilingual block -->
      <div class="bilingual-block">
        <div class="bilingual-inputs">
          <div class="form-group">
            <label>Title (Arabic)</label>
            <input type="text" [(ngModel)]="form.title_ar" name="title_ar"
              placeholder="عنوان الإعلان بالعربية..." dir="rtl" />
          </div>
          <div class="form-group">
            <label>Title (English) <span class="required">*</span></label>
            <input type="text" [(ngModel)]="form.title_en" name="title_en"
              placeholder="Ad title in English..." />
          </div>
        </div>
        <div class="translate-strip">
          <button type="button" class="btn-translate"
            (click)="translateTitleToAr()"
            [disabled]="translating.titleToAr || !form.title_en?.trim()">
            <span *ngIf="!translating.titleToAr">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="15 18 9 12 15 6"/>
              </svg>
              EN → AR
            </span>
            <span *ngIf="translating.titleToAr" class="spinner-xs"></span>
          </button>
          <span class="translate-divider">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 8l4-4 4 4M9 4v16M19 8l-4 4 4 4M15 4v16"/>
            </svg>
            Auto-translate
          </span>
          <button type="button" class="btn-translate"
            (click)="translateTitleToEn()"
            [disabled]="translating.titleToEn || !form.title_ar?.trim()">
            <span *ngIf="!translating.titleToEn">
              AR → EN
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"/>
              </svg>
            </span>
            <span *ngIf="translating.titleToEn" class="spinner-xs"></span>
          </button>
        </div>
        <div class="translate-error" *ngIf="translateErrors.titleToEn || translateErrors.titleToAr">
          Translation failed — please try again.
        </div>
      </div>

      <!-- Name — bilingual block -->
      <div class="bilingual-block">
        <div class="bilingual-inputs">
          <div class="form-group">
            <label>Name / Company (Arabic)</label>
            <input type="text" [(ngModel)]="form.name_ar" name="name_ar"
              placeholder="اسم الشركة أو المعلن بالعربية..." dir="rtl" />
          </div>
          <div class="form-group">
            <label>Name / Company (English) <span class="required">*</span></label>
            <input type="text" [(ngModel)]="form.name_en" name="name_en"
              placeholder="Company or advertiser name..." />
          </div>
        </div>
        <div class="translate-strip">
          <button type="button" class="btn-translate"
            (click)="translateNameToAr()"
            [disabled]="translating.nameToAr || !form.name_en?.trim()">
            <span *ngIf="!translating.nameToAr">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="15 18 9 12 15 6"/>
              </svg>
              EN → AR
            </span>
            <span *ngIf="translating.nameToAr" class="spinner-xs"></span>
          </button>
          <span class="translate-divider">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 8l4-4 4 4M9 4v16M19 8l-4 4 4 4M15 4v16"/>
            </svg>
            Auto-translate
          </span>
          <button type="button" class="btn-translate"
            (click)="translateNameToEn()"
            [disabled]="translating.nameToEn || !form.name_ar?.trim()">
            <span *ngIf="!translating.nameToEn">
              AR → EN
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"/>
              </svg>
            </span>
            <span *ngIf="translating.nameToEn" class="spinner-xs"></span>
          </button>
        </div>
        <div class="translate-error" *ngIf="translateErrors.nameToEn || translateErrors.nameToAr">
          Translation failed — please try again.
        </div>
      </div>

      <!-- Description — bilingual block -->
      <div class="bilingual-block">
        <div class="bilingual-inputs">
          <div class="form-group">
            <label>Description (Arabic)</label>
            <textarea [(ngModel)]="form.description_ar" name="description_ar" rows="5"
              placeholder="وصف الإعلان بالعربية..." dir="rtl"></textarea>
          </div>
          <div class="form-group">
            <label>Description (English)</label>
            <textarea [(ngModel)]="form.description_en" name="description_en" rows="5"
              placeholder="Ad description in English..."></textarea>
          </div>
        </div>
        <div class="translate-strip">
          <button type="button" class="btn-translate"
            (click)="translateDescToAr()"
            [disabled]="translating.descToAr || !form.description_en?.trim()">
            <span *ngIf="!translating.descToAr">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="15 18 9 12 15 6"/>
              </svg>
              EN → AR
            </span>
            <span *ngIf="translating.descToAr" class="spinner-xs"></span>
          </button>
          <span class="translate-divider">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M5 8l4-4 4 4M9 4v16M19 8l-4 4 4 4M15 4v16"/>
            </svg>
            Auto-translate
          </span>
          <button type="button" class="btn-translate"
            (click)="translateDescToEn()"
            [disabled]="translating.descToEn || !form.description_ar?.trim()">
            <span *ngIf="!translating.descToEn">
              AR → EN
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6"/>
              </svg>
            </span>
            <span *ngIf="translating.descToEn" class="spinner-xs"></span>
          </button>
        </div>
        <div class="translate-error" *ngIf="translateErrors.descToEn || translateErrors.descToAr">
          Translation failed — please try again.
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>Phone Number</label>
          <input type="text" [(ngModel)]="form.phone_number" name="phone_number" placeholder="+201000000100" />
        </div>
        <div class="form-group">
          <label>WhatsApp Number</label>
          <input type="text" [(ngModel)]="form.whatsapp_number" name="whatsapp_number" placeholder="+201000000100" />
        </div>
        <div class="form-group check-group">
          <label class="checkbox-label">
            <input type="checkbox" [(ngModel)]="form.is_active" name="is_active" />
            <span>Active</span>
          </label>
        </div>
      </div>
    </div>

    <div class="form-divider"></div>

    <!-- Images Section -->
    <div class="form-section">
      <h2 class="section-title">Images</h2>
      <p class="section-desc">Add image URLs. Press Enter or click Add.</p>

      <app-media-uploader
        folder="ads"
        [multiple]="true"
        accept="image/*"
        (uploaded)="onImagesUploaded($event)">
      </app-media-uploader>

      <div class="url-fallback">
        <span class="or-label">or paste URL</span>
        <div class="media-input-row">
          <input type="text" [(ngModel)]="imageInput" name="imageInput"
            placeholder="https://example.com/image.jpg"
            (keydown)="onImageKeydown($event)" class="media-input" />
          <button type="button" class="btn-add" (click)="addImage()">
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
            Add
          </button>
        </div>
      </div>

      <div class="media-list" *ngIf="form.images.length > 0">
        <div class="media-item" *ngFor="let url of form.images; let i = index">
          <div class="media-thumb">
            <img [src]="url" class="thumb" [alt]="'image-' + i" />
          </div>
          <span class="media-url" [title]="url">{{ url }}</span>
          <span class="media-type">Image</span>
          <button type="button" class="btn-remove" (click)="removeImage(i)">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
      </div>
      <p class="empty-hint" *ngIf="form.images.length === 0">No images added yet.</p>
    </div>

    <div class="form-divider"></div>

    <div class="form-actions">
      <button type="button" class="btn-secondary" (click)="goBack()">Cancel</button>
      <button type="submit" class="btn-primary" [disabled]="isSubmitting">
        <span *ngIf="!isSubmitting">Create Ad</span>
        <span *ngIf="isSubmitting" class="spinner-sm"></span>
      </button>
    </div>

  </form>
</div>
